<template>
    <div :class="classObj" class="app-wrapper">
        <Sidebar class="sidebar-container"></Sidebar>
        <div class="main-container">
            <navbar></navbar>
            <app-main></app-main>
            <div class="bottomBox">
<!--                <div style="border-top:1px solid gray;height: 1px;"></div>-->
                <span style="font-weight: bold;display: block;margin-top: 15px">万德付平台  ©2023  京付公司版权所有</span>
                <!-- <span style="font-weight: bold;display: block;margin-top: 15px">睿收钱  ©2023  </span> -->
            </div>
        </div>
    </div>
</template>

<script>
    import Sidebar from './components/sidebar/index.vue'
    import Navbar from "./components/navbar";
    import AppMain from "./components/appMain";

    export default {
        name: "index",
        components: {
            AppMain,
            Navbar,
            Sidebar
        },
        data() {
            return {}
        },
        computed:{
            sidebar() {
                return this.$store.state.app.sidebar
            },
            classObj() {
                return {
                    hideSidebar: !this.sidebar.opened,
                    openSidebar: this.sidebar.opened,
                }
            }
        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/styles/mixin.scss";

    .app-wrapper {
        @include clearfix;
        position: relative;
        height: 100%;
        width: 100%;
    }

    .bottomBox{
      text-align: center;
      height: 60px;
      background-color: #f2f2f2;
      position: absolute;
      bottom: 0;
      left: 0;
      box-sizing: border-box;
      width: 100%;
      //padding-top: 10px;
      margin-top: 10px;
    }
</style>
